var render = function render(){var _vm=this,_c=_vm._self._c;return _c('emd-alert',{staticClass:"eu-mb_4",attrs:{"variant":"warning","no-close":""}},[_c('template',{slot:"content"},[_c('p',[_vm._v(" "+_vm._s(_vm.computedDescription)+" ")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }